
import { Vue, Options } from "vue-class-component";
import { SttHangingController } from "@/app/ui/controllers/SttHangingController";
import { HistoryHangingIncomingFilterRequest, HistoryHangingIncomingEntities, HistoryHangingIncoming } from '@/domain/entities/HangingIncoming';
import PaginationV3 from "@/app/ui/components/pagination-v3/index.vue";
import { Pagination } from '@/domain/entities/Pagination';
import formatDate from '@/app/infrastructures/misc/common-library/v2/FormatDate';
import FilterHistory from '../components/filter-history.vue'
import { debounce } from 'lodash';

@Options({
  components: {
    PaginationV3,
    FilterHistory
  }
})

class TabRiwayatHangingIncoming extends Vue {
  historyDataEntities = new HistoryHangingIncomingEntities();
  filter = new HistoryHangingIncomingFilterRequest();
  loading = false;
  errorCause = "";

  mounted() {
    this.getHistoryHangingIncoming(new HistoryHangingIncomingFilterRequest());
  }

  get historyPagination() {
    return this.historyDataEntities.pagination;
  }

  get historyData() {
    return this.historyDataEntities.data;
  }

  filterHistoryHangingIncoming = debounce(
    (filter: HistoryHangingIncomingFilterRequest) => {
      if (this.loading) return
      this.filter = filter;
      this.getHistoryHangingIncoming(this.filter);
    },
    250
  );

  async getHistoryHangingIncoming(filter: HistoryHangingIncomingFilterRequest) {
    this.errorCause = "";
    try {
      this.loading = true;
      const res = await SttHangingController.getHistoryHangingIncoming(filter);
      this.historyDataEntities = res;
    } catch(err) {
      this.errorCause = err.response ? "server" : "internet";
    } finally {
      this.loading = false;
    }
  }

  toPageV3(value: number) {
    if (value === this.historyPagination.page) {
      return;
    }
    this.historyDataEntities.pagination.page = value;
    this.filter.page = value;
    this.getHistoryHangingIncoming(this.filter);
  }

  mapHangingDays(item: HistoryHangingIncoming) {
    const colorMap: Record<number, string> = {
      1: "bg-aqua-lp-200 text-aqua-lp-500",
      2: "bg-aqua-lp-200 text-aqua-lp-500",
      3: "bg-aqua-lp-200 text-aqua-lp-500",
      4: "bg-aqua-lp-200 text-aqua-lp-500",
      5: "bg-yellow-lp-200 text-yellow-lp-100",
      6: "bg-orange-lp-100 text-orange-lp-200"
    };

    let color = "bg-white text-gray-lp-300";

    if (item.hangingDays != null) {
      if (colorMap[item.hangingDays]) {
        color = colorMap[item.hangingDays];
      } else if (item.hangingDays >= 7) {
        color = "bg-red-lp-2000 text-white";
      }
    }

    const label =
      item.hangingDays != null
        ? item.hangingDays < 7
          ? `${item.hangingDays} ${this.$t('dashboard.hanging.dayUnit')}`
          : this.$t('dashboard.hanging.day7Plus')
        : "-";

    return { label, color };
  }

  mapTicketStatus(stt: HistoryHangingIncoming) {
    const label: any = {
      "belum_ditemukan": this.$t('dashboard.hanging.statusNotFound'),
      "ditemukan_konsol": this.$t('dashboard.hanging.statusFoundConsole'),
      "ditemukan_pos": this.$t('dashboard.hanging.statusFoundPos')
    }

    const color: any = {
      "belum_ditemukan": "bg-pink-lp-200 text-red-lp-100",
      "ditemukan_konsol": "bg-blue-lp-600 text-blue-lp-700",
      "ditemukan_pos": "bg-purple-lp-100 text-purple-lp-800"
    }

    return {
      label: label[stt.existenceStatus] ?? "-",
      color: color[stt.existenceStatus] ?? ""
    }
  }

  // Format Date
  formatDateToString(date: string) {
    return formatDate(date);
  }

  extractDateTime(input: string) {
    if (!input) return "";

    const dateMatch = input.match(/\b(\d{4})[-/](\d{2})[-/](\d{2})\b/);

    const timeMatch = input.match(/\b(\d{2}):(\d{2})(?::(\d{2}))?\b/);

    const date = dateMatch ? `${dateMatch[1]}-${dateMatch[2]}-${dateMatch[3]}` : null;
    const time = timeMatch ? `${timeMatch[1]}:${timeMatch[2]}` : null;

    return `${date}, ${time}`;
  }
}
export default TabRiwayatHangingIncoming;
